module.exports = __webpack_public_path__ + "img/nafi.658a3170.png";